import { rtkApi } from '@/apis/rtkApi';

export interface Message {
  _id: string;
  contractId: string;
  fromUserId: {
    _id: string;
    name: string;
    email: string;
    role: string;
  };
  toUserId?: {
    _id: string;
    name: string;
    email: string;
    role: string;
  };
  toRole?: 'buyer' | 'seller' | 'agent' | 'seller_agent';
  message: string;
  subject?: string;
  read: boolean;
  readAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface SendMessageRequest {
  contractId: string;
  toUserId?: string;
  toRole?: 'buyer' | 'seller' | 'agent' | 'seller_agent';
  message: string;
  subject?: string;
}

export interface GetMessagesResponse {
  success: boolean;
  messages: Message[];
}

export interface SendMessageResponse {
  success: boolean;
  message: Message;
}

export interface UnreadCountResponse {
  success: boolean;
  count: number;
}

export const messageApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    sendMessage: builder.mutation<SendMessageResponse, SendMessageRequest>({
      query: (data) => ({
        url: '/messages',
        method: 'POST',
        data,
      }),
      invalidatesTags: (_response, _error, { contractId }) => [
        { type: 'Message', id: contractId },
        'Message',
      ],
    }),
    getMessages: builder.query<GetMessagesResponse, string>({
      query: (contractId) => ({
        url: `/messages/${contractId}`,
      }),
      providesTags: (_response, _error, contractId) => [
        { type: 'Message', id: contractId },
        'Message',
      ],
    }),
    getMessagesForAdmin: builder.query<GetMessagesResponse, string>({
      query: (contractId) => ({
        url: `/messages/admin/${contractId}`,
      }),
      providesTags: (_response, _error, contractId) => [
        { type: 'Message', id: contractId },
        'Message',
      ],
    }),
    markMessageAsRead: builder.mutation<SendMessageResponse, string>({
      query: (messageId) => ({
        url: `/messages/${messageId}/read`,
        method: 'PUT',
      }),
      invalidatesTags: ['Message'],
    }),
    getUnreadCount: builder.query<UnreadCountResponse, void>({
      query: () => ({
        url: '/messages/unread/count',
      }),
      providesTags: ['Message'],
    }),
  }),
});

export const {
  useSendMessageMutation,
  useGetMessagesQuery,
  useGetMessagesForAdminQuery,
  useMarkMessageAsReadMutation,
  useGetUnreadCountQuery,
} = messageApi;
